import './components/getDinamicHeight';
import './components/slider';
import './components/smallJS';
import './components/timer';
import './components/accordions';
import './components/modals';
// import './components/tabs';
import './components/burger-menu';


